import {Timeline, TimelineLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HorribleHeroesGameModuleConfig} from "../../HorribleHeroesGameModuleConfig";
import {IHorribleHeroesBigWinRatioConfig} from "../../HorribleHeroesGameConfig";
import {HorribleHeroesParsedGameData} from "../../server/data/HorribleHeroesParsedGameData";
import {SoundManager} from "../../resource/sound/SoundManager";
import {HorribleHeroesSoundConfig} from "../../HorribleHeroesSoundConfig";

export class BigWinStep implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private _fromRatioConfig: IHorribleHeroesBigWinRatioConfig;
    private _toRatioConfig: IHorribleHeroesBigWinRatioConfig;
    private _hasWin: boolean;
    private _countFrom: number;
    private _countTo: number;
    private _lastLevel: boolean;
    private _lastLevelCount: number;

    constructor(fromRatioConfig: IHorribleHeroesBigWinRatioConfig, toRatioConfig: IHorribleHeroesBigWinRatioConfig, stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
        this._fromRatioConfig = fromRatioConfig;
        this._toRatioConfig = toRatioConfig;
    }

    public prepare(data: HorribleHeroesParsedGameData): void {
        this._hasWin = false;
        this._countFrom = 0;
        this._countTo = 0;
        this._lastLevel = false;
        this._lastLevelCount = 0;

        // #414 -> added brokeTheBank
        if (data.singleWin <= 0 || data.brokeTheBank) {
            return;
        }

        this._countFrom = data.playedBetValue * this._fromRatioConfig.ratio;
        const countTo: number = data.playedBetValue * this._toRatioConfig.ratio;
        this._hasWin = data.isBigWin && (countTo <= data.singleWin);
        if ((data.currentWinRatioConfig && data.currentWinRatioConfig.ratio == this._toRatioConfig.ratio)) {
            this._lastLevel = true;
            this._lastLevelCount = data.singleWin;
        }
        this._countTo = this._lastLevel ? data.singleWin : countTo;
    }

    public getAnimation(data: ParsedServerData): Timeline | null {
        if (!this._hasWin) {
            return null;
        }
        const tl: TimelineLite = new TimelineLite(),
            winTextStart: TimelineLite = HorribleHeroesGameModuleConfig.winTextView.getStartAnimation(this._toRatioConfig),
            count: TimelineLite = HorribleHeroesGameModuleConfig.countUpView.getWinStepAnimation(this._countFrom, this._countTo, this._toRatioConfig, undefined, true);

        tl.add([
            winTextStart,
            count,
            // #444
            () => SoundManager.playBigWinLevel(this._toRatioConfig.level)
        ]);

        const winTextEnd: TimelineLite = HorribleHeroesGameModuleConfig.winTextView.getEndAnimation(this._toRatioConfig, this._lastLevel);
        if (this._lastLevel) {
            // #444, #488
            tl.add(() => {
                if (this._toRatioConfig.level === 5) {
                    SoundManager.playBigWinEndsLevel5();
                } else {
                    SoundManager.playBigWinEnds();
                }
            }, this._toRatioConfig.duration);
        }
        // #456
        tl.add(winTextEnd, this._toRatioConfig.duration);

        return tl;
    }

    public abort(isActive: boolean): Timeline | null {
        if (!this._hasWin) {
            return null;
        }

        const tl: TimelineLite = new TimelineLite();

        let count;
        if (this._lastLevel) {
            count = HorribleHeroesGameModuleConfig.countUpView.abort(this._lastLevelCount);
            HorribleHeroesGameModuleConfig.winTextView.abort(this._toRatioConfig);
        } else {
            count = HorribleHeroesGameModuleConfig.countUpView.abort(this._countTo);
        }

        tl.add([
            count,
            // #444
            () => {
                SoundManager.stopSound(HorribleHeroesSoundConfig.instance.BIG_WIN_LEVEL + (this._toRatioConfig.level));

                if (this._lastLevel) {
                    SoundManager.playBigWinEnds();
                }
            }
        ]);

        return tl;
    }
}
